import { Component, ElementRef, OnChanges, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { repeaterAnimation } from 'app/main/pages/invoice/invoice.animation';
import { TipoItemService } from '@core/services/tipo-item.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlanoService } from '@core/services/plano.service';
import moment from 'moment';
import { ClienteService } from '@core/services/cliente.service';
import Swal from 'sweetalert2';
import { PedidoService } from '@core/services/pedido.service';
import { PedidoItemService } from '@core/services/pedido-item.service';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ActivatedRoute, Router } from '@angular/router';
import { DescontoService } from '@core/services/desconto.service';
import { GrupoDescontoService } from '@core/services/grupo-desconto.service';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ChipInterface } from 'app/module/chip.interface';
import { BrokerService } from '@core/services/broker.service';
import { BrokerInterface } from 'app/module/broker-interface';
import { OperadoraService } from '@core/services/operadora.service';
import { OperadoraInterface } from 'app/module/operadora-interface';
import { PlanoInterface } from 'app/module/plano-interface';
import { ChipService } from '@core/services/chip.service';
import { ApnService } from '@core/services/apn.service';
import { ModeloChipService } from '@core/services/modelo-chip.service';

@Component({
	selector: 'app-form-chip',
	templateUrl: './form-chip.component.html',
	styleUrls: ['./form-chip.component.scss'],
	animations: [repeaterAnimation],
	encapsulation: ViewEncapsulation.None
})
export class FormChipComponent implements OnInit {
	@ViewChild('cadastroForm') cadastroForm: NgForm;
	loading: boolean = false;
	href: any;
	contentHeader: object;
	erro: boolean = false;
	chipInterface: ChipInterface = {
		id_chip: null,
		icc_id: '',
		ddd: '',
		id_operadora: 0,
		id_broker: 0,
		id_plano: 0,
		id_contratante: 0,
		id_apn: 0,
		id_estoque: 1,
		id_modelo_chip: null,
		ip: '',
		personalizacao: '',
		consumo: '',
		id_status: 1,
		latitude: '',
		longitude: '',
		id_situacao: 0,
		num_pedido: '',
		lote: '',
		id_contrato: null,
		dt_ativacao: undefined,
		dt_limite: undefined,
		dt_ult_atualizacao: undefined,
		dt_compra: undefined
	}
	starting: boolean = false
	brokers: BrokerInterface;
	operadoras: OperadoraInterface[];
	planos: PlanoInterface[];
	@ViewChild('file', { static: true }) fileInput: ElementRef;
	fileToUpload: File;
	spinnerImportar: boolean = false;
	separador = ';';
	apns;
	modelosChip;
	resultado_show = false;
	resultado_importacao: Array<any> | any = [];

	constructor(
		private modalService: NgbModal,
		private route: ActivatedRoute,
		private planoService: PlanoService,
		private brokerService: BrokerService,
		private operadoraService: OperadoraService,
		private chipService: ChipService,
		private _router: Router,
		private apnService: ApnService,
		private modeloChipService: ModeloChipService
	) { }

	ngOnInit() {
		this.chipInterface.id_chip = this.route.snapshot.params.id;

		this.brokerService.get().subscribe((res) => {
			if (res) this.brokers = res
		})

		this.operadoraService.get().subscribe((res) => {
			if (res) this.operadoras = res
		})

		this.planoService.get().subscribe((res) => {
			if (res) this.planos = res
		})

		this.contentHeader = {
			headerTitle: this.chipInterface.id_chip ? "Editar Chip" : "Cadastrar Chip",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Plano",
						isLink: false,
					},
					{
						name: this.chipInterface.id_chip ? "Editar" : "Cadastrar",
						isLink: false,
					},
				],
			},
		};

		this.apnService.get().subscribe(
			(response) => {
				(this.apns = response)
			},
			(error) => console.log(error)
		)

		this.modeloChipService.get().subscribe(
			(response) => {
				(this.modelosChip = response)
			},
			(error) => console.log(error)
		)

		if (this.chipInterface.id_chip != null) {
			this.chipService.findOne(this.chipInterface.id_chip).subscribe(
				(res) => {
					this.chipInterface = res[0];
				},
				(err) => {
					console.log(err)
				}
			)
		}
	}

	handleFileInput(event) {
		const fileList: FileList = event.target.files;
		if (fileList.length > 0) {
			const file: File = fileList[0];
			this.fileToUpload = file;
		}
	}

	importarCsv(file) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja importar as informações inseridas?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: '#161D31',
			cancelButtonColor: '#6e7d88',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then((result) => {
			if (result.isConfirmed) {
				this.spinnerImportar = true;
				const formData = new FormData();
				formData.append('filename', file);
				formData.append('separador', this.separador);
				this.chipService.importarCsv(formData).subscribe(
					(result) => {
						this.resultado_show = true;
						this.spinnerImportar = false;
						Swal.fire({
							title: "Importado!",
							text: "Confira o resultado a seguir.",
							icon: "success",
							confirmButtonText: "Confirmar",
							confirmButtonColor: '#161D31',
						}).then(() => {
						});
						console.log(result);

						result.forEach(element => {
							let obj = { item: element[0].vIdChip + ': ' + element[0].msg }
							this.resultado_importacao = [...this.resultado_importacao, obj]
						});
					},
					(error) => {
						this.spinnerImportar = false;
						console.log(error);
						this.msgErroInterno()
					}
				)
			}
		})
	}

	modalOpen(modalBasic) {
		const modalRef = this.modalService.open(modalBasic, {
			windowClass: 'modal',
			size: 'lg',
			centered: true
		});

		modalRef.result.then(
			(result) => {
				this.resultado_importacao = [];
				this.resultado_show = false;
			},
			(reason) => {
				this.resultado_importacao = [];
				this.resultado_show = false;
			}
		);
	}

	public submitForm(data: NgForm) {

		if (data.form.valid === true) {
			this.erro = false;
			this.loading = true;

			this.chipInterface.id_apn = Number(this.chipInterface.id_apn);
			this.chipInterface.id_broker = Number(this.chipInterface.id_broker);
			this.chipInterface.id_contratante = Number(this.chipInterface.id_contratante);
			this.chipInterface.id_modelo_chip = Number(this.chipInterface.id_modelo_chip);
			this.chipInterface.id_operadora = Number(this.chipInterface.id_operadora);

			//POST
			if (!this.chipInterface.id_chip) {
				this.chipService.create(this.chipInterface).subscribe(
					(res) => {
						if (res.id_chip) {
							this.loading = false;
							Swal.fire({
								title: "Plano cadastrado!",
								text: "O item foi cadastrado com sucesso.",
								icon: "success",
								confirmButtonText: "Confirmar",
								confirmButtonColor: '#161D31',
							}).then(() => {
								this._router.navigate(['chip'])
							});
						} else {
							this.msgErroInterno()
						}
					},
					(error) => {
						console.log(error);
						this.msgErroInterno()
					}
				);
			} else {
				this.chipService.update(this.chipInterface).subscribe(
					(res) => {
						if (res) {
							this.loading = false;
							Swal.fire({
								title: "Plano atualizado!",
								text: "O item foi atualizado com sucesso.",
								icon: "success",
								confirmButtonText: "Confirmar",
								confirmButtonColor: '#161D31',
							}).then(() => {
								this._router.navigate(['chip'])
							});
						} else {
							this.msgErroInterno()
						}
					},
					(error) => {
						console.log(error);
						this.msgErroInterno()
					}
				);
			}
		} else {
			this.loading = false;
			Swal.fire({
				title: "Preencha todos os campos!",
				text: "Preencha todos os campos para salvar.",
				icon: "error",
				confirmButtonText: "Confirmar",
				confirmButtonColor: '#ef6767',
			});
		}

		if (this.erro) {
			this.loading = false;
			Swal.fire({
				title: "Erro!",
				text: "Preencha os campos broker, tipo item e tipo fluxo.",
				icon: "error",
				confirmButtonText: "Confirmar",
				confirmButtonColor: '#ef6767',
			});
		}
	}

	msgErroInterno() {
		this.loading = false;
		Swal.fire({
			title: "Erro!",
			text: "Ocorreu um erro interno.",
			icon: "error",
			confirmButtonText: "Confirmar",
			confirmButtonColor: '#ef6767',
		});
	}

	// ngOnDestroy() {
	//   this.routeSub.unsubscribe();
	// }
}
